import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Slider from 'react-slick';
import SiderNavigation from '../../slider/slider-navigation';
import ProjectBlurb from '../project-blurb';
import '../../../utils/slick-slider-styles/slick-main.css';
import { css } from 'emotion';
import styles from './slider.module.css';

class ProjectSlider extends Component {
  constructor() {
    super();
    this.state = {
      activeSlide: 0,
    };
  }

  prevSlide = () => {
    this.slider.slickPrev();
  };
  nextSlide = () => {
    this.slider.slickNext();
  };

  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      afterChange: current => this.setState({ activeSlide: current }),
    };

    const { slides, animation, wrapperPadding, blurb } = this.props;

    return (
      <div
        className={css`
          padding: ${wrapperPadding[1]};
          @media (min-width: 415px) {
            padding: ${wrapperPadding[0]};
          }
        `}
        style={animation}
      >
        {slides && (
          <div className={styles.wrapper}>
            <Slider ref={slider => (this.slider = slider)} {...settings}>
              {slides.map((slide, index) => {
                const slideSizes = slide.slide.localFile.childImageSharp.sizes;
                return (
                  <div className={styles.imageWrapper} key={index}>
                    <Img sizes={slideSizes} backgroundColor={true} />
                  </div>
                );
              })}
            </Slider>
            <SiderNavigation
              prevSlide={this.prevSlide}
              nextSlide={this.nextSlide}
              sliderLength={slides.length}
              activeSlide={this.state.activeSlide}
              navType={'case-study'}
              navPos={0}
              color={'f0f0f2'}
            />
          </div>
        )}
        <ProjectBlurb blurb={blurb} />
      </div>
    );
  }
}

ProjectSlider.propTypes = {
  slides: PropTypes.array,
  animation: PropTypes.object,
  wrapperPadding: PropTypes.array,
  blurb: PropTypes.string,
};

export default ProjectSlider;



// WEBPACK FOOTER //
// ./src/components/project/project-slider/index.js